export const PARENT_DOMAIN="https://um.ids.com.lb/"
export const PHONE_NUMBER='+965 188 30 30'
export const REGISTER_URL = `${PARENT_DOMAIN}register`;